/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_Cost_IncompleteInputs */

const en_read_along_ai_cost_incomplete = /** @type {(inputs: Read_Along_Ai_Cost_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total cost is unavailable because an interrupted attempt may have been charged.`)
};

const es_read_along_ai_cost_incomplete = /** @type {(inputs: Read_Along_Ai_Cost_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El costo total no está disponible porque un intento interrumpido podría haberse cobrado.`)
};

/**
* | output |
* | --- |
* | "Total cost is unavailable because an interrupted attempt may have been charged." |
*
* @param {Read_Along_Ai_Cost_IncompleteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_cost_incomplete = /** @type {((inputs?: Read_Along_Ai_Cost_IncompleteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_Cost_IncompleteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_cost_incomplete(inputs)
	return en_read_along_ai_cost_incomplete(inputs)
});